import { render, staticRenderFns } from "./pageLoader.vue?vue&type=template&id=df58d070&scoped=true&"
import script from "./pageLoader.vue?vue&type=script&lang=js&"
export * from "./pageLoader.vue?vue&type=script&lang=js&"
import style0 from "./pageLoader.vue?vue&type=style&index=0&id=df58d070&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df58d070",
  null
  
)

export default component.exports